import React from 'react';

import { getImageUrl } from '@zego/imgixUtils';

import FluidBackgroundImageBase from './FluidBackgroundImageBase';

export default function StaticBackgroundImage({ src, ...props }) {
  return <FluidBackgroundImageBase src={getImageUrl(src)} {...props} />;
}
